var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
const RangeDatePicker = (_a) => {
    var { startDate, endDate, onChange } = _a, rest = __rest(_a, ["startDate", "endDate", "onChange"]);
    const [range, setRange] = useState({
        startDate: startDate !== null && startDate !== void 0 ? startDate : new Date(),
        endDate: endDate !== null && endDate !== void 0 ? endDate : new Date(),
        key: 'selection'
    });
    const handleSelect = (ranges) => {
        setRange(ranges.selection);
        onChange === null || onChange === void 0 ? void 0 : onChange({ startDate: ranges.selection.startDate, endDate: ranges.selection.endDate });
    };
    return React.createElement(DateRangePicker, Object.assign({}, rest, { ranges: [range], onChange: handleSelect }));
};
export default RangeDatePicker;
